// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.booking-ref__input[data-v-32beb620] {\n  margin-bottom: 0;\n}\n.booking-ref__input-note[data-v-32beb620] {\n  margin-top: 5px;\n  font-weight: bold;\n  font-size: 12px;\n}\n.booking-ref__checkbox[data-v-32beb620] {\n  margin-top: 5px;\n}\n.sk-input-warning-hint[data-v-32beb620] {\n  margin-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
